import { createPortal } from "react-dom";
import { CheckCircle2 } from "lucide-react";
import { Button, Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@repo/ui";

interface CompletionModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function CompletionModal({ isOpen, onClose }: CompletionModalProps) {
  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <Card className="w-full max-w-md mx-4">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 w-16 h-16 rounded-full bg-green-100 flex items-center justify-center">
            <CheckCircle2 className="h-10 w-10 text-green-600" />
          </div>
          <CardTitle className="text-2xl">Entretien terminé</CardTitle>
          <CardDescription className="text-base mt-2">
            Merci d'avoir participé à cet entretien FairView. Vos réponses ont
            été enregistrées avec succès.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center text-sm text-muted-foreground">
          <p>
            Vous pouvez maintenant fermer cette fenêtre. Vos réponses resteront
            accessibles en lecture seule.
          </p>
        </CardContent>
        <CardFooter>
          <Button onClick={onClose} className="w-full" size="lg">
            Fermer
          </Button>
        </CardFooter>
      </Card>
    </div>,
    document.body,
  );
}
